import { call, select, delay } from 'redux-saga/effects';
import get from 'lodash/get';
import { getGallectionById, getGrusername } from '../selectors';
import { requestPuppy } from '@wix/da-http-client';
import { getGallectionType } from '../helpers';
function* setGallectionDescription(action) {
    yield delay(500); // + takeLatest = debounced
    const { folderId, description } = action.payload;
    const gallection = yield select(getGallectionById, folderId);
    const username = yield select(getGrusername);
    if (!gallection) {
        return;
    }
    var _getGallectionType;
    const params = {
        username,
        type: (_getGallectionType = getGallectionType(gallection)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'collection',
        folderid: gallection.folderId,
        name: gallection.name,
        description,
        cover_deviationid: gallection.type === 'stash' ? undefined : get(gallection, 'thumb.deviationId')
    };
    yield call(requestPuppy, {
        method: 'post',
        url: 'gallection/folders/update',
        data: params
    });
}
export default setGallectionDescription;

//# sourceMappingURL=saveChangedGallectionDescription.js.map